import { Breadcrumb } from "antd";
import React from "react";

export default function BannerComp({ title, breadcrumb, image }) {
  const styles = {
    backgroundImage: `url(${image})`,
    backgroundPosition:
      title === "Certified Diamonds" ||
      title === "Blog" ||
      title === "FREE TIPS TO BUY DIAMONDS ON THE INTERNET"
        ? "center center"
        : title === "Fancy Shape & Color"
        ? "center bottom"
        : title === "Custom & Special Orders"
        ? "center top"
        : title === "Certified Melee Diamonds" ? "center 37%" : undefined,
    backgroundSize: title === "Certified Diamonds" && "cover",
  };
  return (
    <div className="abouts-us-banner-div" style={styles}>
      <h1>{title}</h1>
      <Breadcrumb items={breadcrumb} />
    </div>
  );
}
